import { Pipe, PipeTransform, inject } from '@angular/core';
import { Params, Translator } from 'shared-ui/providers/translator';

@Pipe({
  name: 'translate',
  standalone: false,
})
export class TranslatorPipe implements PipeTransform {
  protected translator = inject(Translator);

  transform(value: string, params?: Params, language?: string): string {
    return this.translator.translate(value, params, language);
  }
}

@Pipe({
  name: 't',
  standalone: false,
})
export class TranslatorAliasPipe extends TranslatorPipe implements PipeTransform {}
